import { TranslateService } from '@ngx-translate/core';

import { BookingDiaryMechanicModel } from './typings/booking-diary.mechanic';
import { BookingDiaryVehicleModel }  from './typings/booking-diary.customer';
import { DropdownOptionModel }       from '../shared/components/dropdown/typings/dropdown-option';

import {
  formatClockLabel,
  SLOT_MINUTES
} from './booking-diary.layout';

// the mechanics as a dropdown, with the unassigned choice first
export function mechanicOptionsFor ( mechanics : Array<BookingDiaryMechanicModel>, translateService : TranslateService ) : Array<DropdownOptionModel> {
  return [
    {
      label: translateService.instant('JS_SPACE.BOOKINGS.UNASSIGNED'),
      value: null
    },
    ...mechanics.map(mechanic => ( {
      label: mechanic.name,
      value: mechanic.id
    } ))
  ];
}

// every slot start the shop is open for, as a dropdown
export function timeOptionsBetween ( opensMinutes : number, closesMinutes : number ) : Array<DropdownOptionModel> {
  const options : Array<DropdownOptionModel> = [];

  for ( let minutes = opensMinutes; minutes <= closesMinutes - SLOT_MINUTES; minutes += SLOT_MINUTES ) {
    options.push({
      label: formatClockLabel(minutes),
      value: minutes
    });
  }

  return options;
}

// make, model and plate, whichever the vehicle has
export function vehicleLabel ( vehicle : { make ?: string; model ?: string; plate_number ?: string } ) : string {
  return [ vehicle.make, vehicle.model, vehicle.plate_number ].filter(part => !!part).join(' ');
}

// a customer's vehicles as a dropdown; the empty choice says whether there are any
export function vehicleOptionsFor ( vehicles : Array<BookingDiaryVehicleModel>, translateService : TranslateService ) : Array<DropdownOptionModel> {
  return [
    {
      label: translateService.instant(vehicles.length
        ? 'BOOKING_SPACE.DIARY.NO_VEHICLE'
        : 'BOOKING_SPACE.DIARY.NO_VEHICLES_ON_FILE'),
      value: null
    },
    ...vehicles.map(vehicle => ( {
      label: vehicleLabel(vehicle),
      value: vehicle.id
    } ))
  ];
}
